import { cn } from '../../lib/cn';

export default function Input({
  className,
  type = 'text',
  error,
  ...props
}) {
  return (
    <input
      type={type}
      className={cn(
        'w-full px-4 py-3 rounded-lg',
        'bg-white border border-gray-200',
        'dark:bg-gray-800 dark:border-gray-600',
        'shadow-[inset_0_1px_3px_rgba(0,0,0,0.06)]',
        'text-gray-900 placeholder-gray-400',
        'dark:text-white dark:placeholder-gray-500',
        'transition-all duration-200',
        'focus:outline-none focus:border-gray-400 focus:shadow-[inset_0_1px_3px_rgba(0,0,0,0.06),0_0_0_3px_rgba(156,163,175,0.2)]',
        'dark:focus:border-gray-500 dark:focus:shadow-[inset_0_1px_3px_rgba(0,0,0,0.06),0_0_0_3px_rgba(107,114,128,0.3)]',
        error && 'border-red-300 focus:border-red-400 focus:shadow-[inset_0_1px_3px_rgba(0,0,0,0.06),0_0_0_3px_rgba(239,68,68,0.2)]',
        'disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed',
        'dark:disabled:bg-gray-700 dark:disabled:text-gray-500',
        className
      )}
      {...props}
    />
  );
}

export function Textarea({
  className,
  error,
  rows = 4,
  autoExpand = false,
  ...props
}) {
  const handleInput = (e) => {
    if (autoExpand) {
      e.target.style.height = 'auto';
      e.target.style.height = `${e.target.scrollHeight}px`;
    }
    props.onInput?.(e);
  };

  return (
    <textarea
      rows={rows}
      className={cn(
        'w-full px-4 py-3 rounded-lg',
        'bg-white border border-gray-200',
        'dark:bg-gray-800 dark:border-gray-600',
        'shadow-[inset_0_1px_3px_rgba(0,0,0,0.06)]',
        'text-gray-900 placeholder-gray-400',
        'dark:text-white dark:placeholder-gray-500',
        'transition-all duration-200',
        'focus:outline-none focus:border-gray-400 focus:shadow-[inset_0_1px_3px_rgba(0,0,0,0.06),0_0_0_3px_rgba(156,163,175,0.2)]',
        'dark:focus:border-gray-500 dark:focus:shadow-[inset_0_1px_3px_rgba(0,0,0,0.06),0_0_0_3px_rgba(107,114,128,0.3)]',
        error && 'border-red-300 focus:border-red-400 focus:shadow-[inset_0_1px_3px_rgba(0,0,0,0.06),0_0_0_3px_rgba(239,68,68,0.2)]',
        'disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed',
        'dark:disabled:bg-gray-700 dark:disabled:text-gray-500',
        'resize-none',
        autoExpand && 'overflow-hidden',
        className
      )}
      onInput={handleInput}
      {...props}
    />
  );
}

export function InputLabel({ children, htmlFor, required, className }) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn('block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5', className)}
    >
      {children}
      {required && <span className="text-red-500 ml-0.5">*</span>}
    </label>
  );
}

export function InputError({ children, className }) {
  if (!children) return null;
  return (
    <p className={cn('mt-1.5 text-sm text-red-500', className)}>
      {children}
    </p>
  );
}

export function InputGroup({ children, className }) {
  return (
    <div className={cn('space-y-1', className)}>
      {children}
    </div>
  );
}
